export default __webpack_public_path__ + "static/media/remove.81b4a803.svg";